<template>
  <div>
    <div v-if="currentUserFavorites.length == 0">
      <b-message
        type="is-info"
        has-icon
      >
        Nenhum profissional foi adicionado aos favoritos ainda.
        Quando você adicionar um profissional à sua lista de favoritos, ele aparecerá aqui.
      </b-message>
    </div>
    <div
      v-else
      class="flex flex-wrap"
    >
      <div
        v-for="(professional, i) in currentUserFavorites"
        :key="i"
        class="rounded bg-white shadow-md flex flex-wrap items-center text-left p-4 m-2 justify-around"
      >
        <span
          class=" professional-avatar m-2"
          :style="{backgroundImage: `url('${professional.profilePictureUrl || `https://ui-avatars.com/api/?size=512&background=386B61&color=fff&name=${professional.name}+${professional.lastName}`} ')` }"
        />
        <div class="flex flex-col items-start mx-2 w-64">
          <h2 class="text-left my-2">
            {{ professional.name }} {{ professional.lastName }}
          </h2>
          <span>
            {{ professional.title }}
          </span>
          <div
            v-if="professional.address"
            class="professional-card-address titlecase flex"
          >
            <b-icon
              icon="map-marker"
              class="tag-text"
            />
            <strong class="text-left">
              {{ professional.address.city }} {{ professional.address.state && ` - ${professional.address.state}`}}
            </strong>
          </div>
          <div class="text-left items-start">
            <router-link
              :to="`/profiles/${professional.userId}`"
              class="button mr-2 my-2"
            >
              <b-tooltip label="Ver Perfil">
                <b-icon icon="eye" />
              </b-tooltip>

            </router-link>
            <span
              class="button is-danger m-2"
              @click="handleRemove(professional.userId)"
            >
              <b-tooltip label="Remover">
                <b-icon icon="delete" />
              </b-tooltip>
            </span>
          </div>
        </div>
        <div class="professional-card-specialties tags-wrapper">
          <span
            class="tag-light"
            v-for="(specialty, index) in professional.specialties"
            :key="index"
          ><span class="tag-text">{{specialty}}</span></span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState(['currentUserFavorites'])
  },
  created () {
    this.$store.dispatch('fetchFavoriteProfessionals')
  },
  methods: {
    handleRemove (id) {
      this.$buefy.dialog.confirm({
        message: 'Tem certeza que deeja remover este profissional dos favoritos?',
        cancelText: 'Cancelar',
        onConfirm: () => this.removeProfessiional(id)
      })
    },

    async removeProfessiional (id) {
      try {
        await this.$store.dispatch('removeProfessionalFromFavorites', id)
        this.$toasted.success('Profissional removido da sua lista de favoritos')
      } catch (error) {
        this.$toasted.error('Não foi possível remover esse profissional. Tente novamente mais tarde')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
